import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fmtMXN = (n) =>
    new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        maximumFractionDigits: 2,
    }).format(Number(n || 0));

export const fmtDate = (d) => {
    if (!d) return "";
    try {
        let date;
        if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
            // Date-only string: parse as local date to avoid UTC→local shift
            const [y, m, day] = d.split("-").map(Number);
            date = new Date(y, m - 1, day);
        } else {
            date = typeof d === "string" ? new Date(d) : d;
        }
        return new Intl.DateTimeFormat("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).format(date);
    } catch {
        return String(d);
    }
};

const localISO = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
};

export const todayISO = () => localISO(new Date());

export const daysAgoISO = (n) => {
    const d = new Date();
    d.setDate(d.getDate() - n);
    return localISO(d);
};

const TOKEN_KEY = "casas_tracking_token";

export const withToken = (url) => {
    const token = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
    if (!token) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}token=${encodeURIComponent(token)}`;
};
